import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template134: Día 3 - Changdeokgung e Ikseon-dong
// Adaptado del componente PageChangdeokgung.jsx de guia-seul para usar las props del sistema guia
const Template134 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const changdeokgungImage = getImageSrc("changdeokgung");
	const ikseonImage = getImageSrc("ikseon");
	const jardinSticker = getCanvasImageUrl("jardin-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const heroTitle = page?.texts?.[1]?.content;
	const introText = page?.texts?.[2]?.content;
	const hanbokBoxText = page?.texts?.[3]?.content;
	const changdeokTitle = page?.texts?.[4]?.content;
	const changdeokDesc = page?.texts?.[5]?.content;
	const jardinTitle = page?.texts?.[6]?.content;
	const jardinDesc = page?.texts?.[7]?.content;
	const ikseonTitle = page?.texts?.[8]?.content;
	const ikseonDesc = page?.texts?.[9]?.content;
	const sabiasQueChangdeok = page?.texts?.[10]?.content;
	const sabiasQueJardin = page?.texts?.[11]?.content;

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{(portadaImage || jardinSticker) && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					{portadaImage && (
						<img
							src={portadaImage}
							alt=""
							style={{ width: "100%", height: 200, objectFit: "cover" }}
						/>
					)}
					{jardinSticker && (
						<img
							src={jardinSticker}
							alt=""
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: isSmallScreen ? 60 : -10,
								right: isSmallScreen ? "auto" : 0,
								left: isSmallScreen ? 25 : "auto",
							}}
						/>
					)}
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: "32px",
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{hanbokBoxText && (
				<Box
					data-block-id="text-2"
					sx={{ padding: "8px 12px", marginBottom: "8px", marginTop: "-4px" }}
				>
					<Box
						sx={{
							backgroundColor: "#caeae6",
							border: "3px solid #2e8b80",
							borderRadius: "12px",
							padding: "8px 20px",
							fontSize: 13,
							fontFamily: "'Poppins', sans-serif",
							color: "#333",
							width: "100%",
						}}
					>
						{hanbokBoxText}
					</Box>
				</Box>
			)}

			<Box>
				{(changdeokTitle || changdeokDesc || changdeokgungImage) && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							gap: "16px",
							padding: "0 12px",
							position: "relative",
						}}
					>
						{changdeokgungImage && (
							<img
								src={changdeokgungImage}
								alt=""
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						{sabiasQueChangdeok && (
							<Box
								sx={{ position: "absolute", top: 0, left: "33%", zIndex: 999 }}
							>
								<SabiasQue icono="🏛️" texto={sabiasQueChangdeok} />
							</Box>
						)}
						<Box sx={{ width: "60%" }}>
							{changdeokTitle && (
								<Box component="h3" sx={h3}>
									{changdeokTitle}
								</Box>
							)}
							{changdeokDesc && (
								<Box component="p" sx={p}>
									{changdeokDesc}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{(jardinTitle || jardinDesc) && (
					<Box data-block-id="text-4" sx={{ padding: "0px 12px", paddingTop: "14px" }}>
						<Box
							sx={{
								backgroundColor: "#caeae6",
								padding: "12px",
								borderRadius: "12px",
								display: "flex",
								gap: "16px",
								alignItems: "center",
								position: "relative",
								marginBottom: isSmallScreen ? "20px" : 0,
							}}
						>
							<Box sx={{ width: "100%" }}>
								{jardinTitle && (
									<Box component="h3" sx={h3}>
										{jardinTitle}
									</Box>
								)}
								{jardinDesc && (
									<Box component="p" sx={p}>
										{jardinDesc}
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				)}

				{(ikseonTitle || ikseonDesc || ikseonImage) && (
					<Box
						data-block-id="text-5"
						sx={{
							display: "flex",
							gap: "16px",
							padding: "0 12px",
							marginTop: "14px",
							marginBottom: isSmallScreen ? "14px" : "0px",
							position: "relative",
						}}
					>
						{ikseonImage && (
							<img
								src={ikseonImage}
								alt=""
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						{sabiasQueJardin && (
							<Box
								sx={{
									position: "absolute",
									top: -30,
									left: "33%",
									zIndex: 999,
								}}
							>
								<SabiasQue icono="🌿" texto={sabiasQueJardin} />
							</Box>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{ikseonTitle && (
								<Box component="h3" sx={h3}>
									{ikseonTitle}
								</Box>
							)}
							{ikseonDesc && (
								<Box component="p" sx={p}>
									{ikseonDesc}
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template134.thumbnail = "/images/template-1.png";

export default Template134;
